import { useState } from 'react';
import { HelpCircle, Download, Printer } from 'lucide-react';
import ManualLibroCaja from '../components/ManualLibroCaja';
import ManualCaja from '../components/ManualCaja';
import ManualKits from '../components/ManualKits';

// Seccion de Ayuda / manuales. 2026-10-20: Libro de caja. 2026-10-23: Precios, comprobantes
// RI/RE y cierre de caja. 2026-11-02: Kits. Cada PDF descargable se genera imprimiendo /ayuda/imprimir?manual=...
// (version sin menu) y se guarda en public/ayuda/. index.css oculta #root al imprimir (solo
// salen los tickets termicos); esta pagina lo vuelve a mostrar, solo mientras esta abierta.
const MANUALES = {
  caja: { titulo: 'Precios, comprobantes y cierre de caja', pdf: '/ayuda/Manual_Precios_Comprobantes_Cierre.pdf', Comp: ManualCaja },
  libro: { titulo: 'Libro de caja', pdf: '/ayuda/Manual_Libro_de_Caja.pdf', Comp: ManualLibroCaja },
  kits: { titulo: 'Kits', pdf: '/ayuda/Manual_Kits.pdf', Comp: ManualKits },
} as const;
type Clave = keyof typeof MANUALES;

const Ayuda = () => {
  const [actual, setActual] = useState<Clave>('caja');
  const m = MANUALES[actual];
  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-wrap justify-between items-center gap-3 mb-4">
          <h1 className="text-3xl font-bold flex items-center gap-3">
            <HelpCircle className="text-blue-600" size={32} />
            Ayuda y manuales
          </h1>
          <div className="flex gap-2">
            <a href={m.pdf} download className="flex items-center gap-2 px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700 text-white text-sm font-semibold">
              <Download size={16} /> Descargar PDF
            </a>
            <a href={`/ayuda/imprimir?manual=${actual}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 px-4 py-2 rounded-lg border bg-white hover:bg-gray-50 text-sm font-semibold">
              <Printer size={16} /> Imprimir
            </a>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mb-4">
          {(Object.keys(MANUALES) as Clave[]).map(k => (
            <button key={k} onClick={() => setActual(k)}
              className={`px-4 py-2 rounded-lg text-sm font-semibold border ${actual === k ? 'bg-blue-600 text-white border-blue-600' : 'bg-white hover:bg-gray-50'}`}>
              {MANUALES[k].titulo}
            </button>
          ))}
        </div>
        <div className="bg-white rounded-xl shadow p-5 md:p-8">
          <m.Comp />
        </div>
      </div>
    </div>
  );
};

export const AyudaImprimir = () => {
  const k = (new URLSearchParams(window.location.search).get('manual') as Clave) || 'libro';
  const M = (MANUALES[k] || MANUALES.libro).Comp;
  return (
    <div className="bg-white p-8 max-w-4xl mx-auto manual-impresion">
      <style>{`
        @page { size: A4; margin: 14mm; }
        @media print {
          html body #root { display: block !important; }
          .manual-seccion { break-inside: auto; }
          .manual-impresion .fila-imagenes { display: block !important; }
          .manual-imagen { display: block; break-inside: avoid; page-break-inside: avoid; max-height: 105mm; width: auto; max-width: 100%; margin: 3mm 0; }
          h2 { break-after: avoid; page-break-after: avoid; }
          li, p { break-inside: avoid; }
        }
      `}</style>
      <M />
    </div>
  );
};

export default Ayuda;
